package com.rosario.juridico.premium

import com.rosario.juridico.platform.FirebaseProxy
import com.rosario.juridico.platform.BackendClient
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch

/**
 * Implementación de PurchaseProvider para Web utilizando MercadoPago.
 * Implementa la creación segura de preferencias desde el servidor.
 */
class MercadoPagoWebProvider : PurchaseProvider {
    
    private val scope = CoroutineScope(Dispatchers.Main)

    override fun startPurchase(plan: PremiumPlan) {
        println("[MercadoPagoWebProvider] Iniciando flujo Web para plan ${plan.id}")
        
        scope.launch {
            val uid = FirebaseProxy.getCurrentUserId()
            if (uid == null) {
                println("[MercadoPagoWebProvider] ERROR: UID nulo")
                PremiumPurchaseManager.notifyPurchaseError("Usuario no autenticado.")
                return@launch
            }

            try {
                // 1. Obtener datos de preferencia desde el backend seguro
                println("[MercadoPagoWebProvider] Llamando a BackendClient.crearPreferencia...")
                val prefData = BackendClient.crearPreferencia(plan.id)
                
                if (prefData != null && prefData.init_point != null) {
                    println("[MercadoPagoWebProvider] Full Page Redirect hacia Checkout: ${prefData.init_point}")
                    // Redirección de página completa (Full Page Redirect).
                    // Destruye temporalmente el lienzo de Compose Web y cede el 100% del control
                    // al entorno de Mercado Pago, evitando bloqueos de CVV en contenedores PWA/WebView.
                    kotlinx.browser.window.location.href = prefData.init_point
                } else {
                    val errorMsg = prefData?.error ?: "No se pudo generar el enlace de pago."
                    println("[MercadoPagoWebProvider] ERROR: $errorMsg")
                    PremiumPurchaseManager.notifyPurchaseError(errorMsg)
                }

            } catch (e: Exception) {
                println("[MercadoPagoWebProvider] EXCEPCIÓN: ${e.message}")
                PremiumPurchaseManager.notifyPurchaseError("Error al conectar con la pasarela.")
            }
        }
    }

    override fun restorePurchases() {
        val uid = FirebaseProxy.getCurrentUserId()
        if (uid != null) {
            scope.launch {
                PremiumPurchaseManager.notifyRestoreSuccess(uid)
            }
        } else {
            PremiumPurchaseManager.notifyPurchaseError("No hay sesión activa.")
        }
    }

    override fun cancelPurchase() {
        println("Web: Cancelando flujo MercadoPago.")
        PremiumPurchaseManager.resetState()
    }
}
